<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import { useBookingWidgetContext } from '@/types/booking-widget-context';

const { t } = useI18n();
const context = useBookingWidgetContext();

// Only opens the calendar: picking a date there fetches the sessions
function handleClick() {
  if (context.bookingWidget.isLoadingAvailabilities.value)
    return;

  context.bookingWidget.openDateDropdown();
}
</script>

<template>
  <button
    class="availability-check-button"
    :disabled="context.bookingWidget.isLoadingAvailabilities.value"
    @click="handleClick"
  >
    {{ context.bookingWidget.isLoadingAvailabilities.value ? t('booking.loading') : t('booking.checkAvailability') }}
  </button>
</template>

<style scoped lang="css">
.availability-check-button {
  width: 100%;
  height: 56px;
  padding: var(--yb-spacing-sm);
  background-color: var(--yb-color-primary);
  color: var(--yb-color-white);
  border: none;
  border-radius: var(--yb-radius-sm);
  font-size: var(--yb-text-sm);
  font-weight: var(--yb-text-bold);
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
}

@media (prefers-reduced-motion: reduce) {
  .availability-check-button {
    transition: none;
  }
}
</style>
